import { AbilityBuilder } from "@casl/ability";

import { toArray } from "utils/object";
import { getGroup, getBases } from "utils/auth";

function subjectName(item) {
    if (!item || typeof item === "string") {
        return item;
    }

    return item.__type;
}

export const ability = AbilityBuilder.define({ subjectName }, (can) => {
    can(["read"], "dashboard", { show: true });
    can(["read"], "usuarios", { show: true });
    can(["read"], "pesquisar", { show: true });
    can(["read"], "pesquisar", { show: true });
    can(["read"], "ferramentas", { show: true });
    can(["read"], "verificadas", { show: true });
    can(["read"], "romaneios", { show: true });
    can(["read"], "protocolos", { show: true });
    can(["read"], "aplicativo", { show: true });
    can(["read"], "auditoria", { show: true });
    can(["read"], "rota", { show: true });
    can(["read"], "frete", { show: true });
    can(["read"], "devolucao", { show: true });
    can(["read"], "cte", { show: true });
    can(["read"], "prazoEntrega", { show: true });
});

export const updatePermissions = ({ auth }) => {
    ability.update(defineRulesFor(auth));
};

const defineRulesFor = (auth) => {
    const { can, rules } = AbilityBuilder.extract();

    const activeBases = getBases(auth, { active: true, name: true });

    if (auth) {
        const bases = toArray(getGroup(auth).bases);

        bases.forEach((base) => {
            if (!activeBases.includes(base.id)) return;

            const modules = toArray(base.data.modulos);

            modules.forEach((module) => {
                can("ler", module.id);
            });

            if (getGroup(auth).getUser().isGroupAtivos()) {
                can("ler", "dashboard");
                can("ler", "protocolo");
                can("ler", "romaneio");
                can("ler", "usuario");
            }
        });
    }

    return rules;
};
